import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  extensions: [],
  allExtensions: [],
  totalPages: 0,
  totalRecords: 0,
  extension: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_27: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Extensions(state, extensions) {
    state.extensions = extensions.items;
    state.totalPages = extensions.totalPages;
    state.totalRecords = extensions?.totalRecords ?? 0;
  },
  SET_AllExtensions(state, extensions) {
    state.allExtensions = extensions;
  },
  SET_Extension(state, extension) {
    state.extension = extension;
  },
};
const actions = {
  errorExtension({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllExtensions({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Extensions/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllExtensions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorExtension', error);
      });
  },
  getAllExtensionsWithCityId({ commit, dispatch, rootState }, cityId) {
    return apiClient
      .get('/Extensions/All?CityId=' + cityId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllExtensions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorExtension', error);
      });
  },
  addExtension({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Extensions', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorExtension', error);
      });
  },
  getExtension({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Extensions/ById?extensionId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Extension', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorExtension', error);
      });
  },
  editExtension({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Extensions/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorExtension', error);
      });
  },
  deleteExtension({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Extensions/Remove?extensionId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorExtension', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
